<template>
  <!-- 教师课后反馈提醒 -->

  <div class="popup" style="background: #fff">
    <div style="display: flex; justify-content: space-around; font-weight: 800">
      <div
        style="
          width: 200px;
          background-color: rgb(251 201 30);
          height: 90px;
          border-radius: 10px;
        "
      >
        <div style="display: flex; padding-top: 30px; padding-left: 16px">
          全部课后反馈:{{ dataTop.allTotal }}
        </div>
      </div>
      <div
        style="
          width: 200px;
          background-color: rgb(125 219 218);
          height: 90px;
          border-radius: 10px;
        "
      >
        <div>
          <div style="display: flex; padding-top: 18px; padding-left: 16px">
            教师已完成反馈:{{ dataTop.teacherOk }}
          </div>
          <div style="display: flex; padding-top: 10px; padding-left: 16px">
            教师未完成反馈:{{ dataTop.teacherNotOk }}
          </div>
        </div>
      </div>
      <div
        style="
          width: 200px;
          background-color: rgb(243 177 224);
          height: 90px;
          border-radius: 10px;
        "
      >
        <div>
          <div style="display: flex; padding-top: 18px; padding-left: 16px">
            销售已完成反馈:{{ dataTop.marketOk }}
          </div>
          <div style="display: flex; padding-top: 10px; padding-left: 16px">
            销售未完成反馈:{{ dataTop.marketNotOk }}
          </div>
        </div>
      </div>
    </div>

    <p class="popup_top" style="text-align: left; margin-top: 15px">
      <i class="el-icon-warning" style="color: #0e99db; margin-right: 5px"></i
      ><span style="margin-right: 20px">教师课后反馈提醒</span>
    </p>
    <!-- <el-form class="demo-form-inline" label-width="120px"> -->

    <el-row style="margin-bottom: 20px">
      <el-col :span="8">
        <div  class=""   style="display: flex;"  >
          <span style="margin-right: 10px; padding-top: 10px; width: 100px; ">日期</span >
          <el-date-picker
            style="width: 60%; padding-left: 39px;"
            v-model="classFirstDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable >
          </el-date-picker>
        </div>
      </el-col>

      <el-col :span="8">
        <div  class=""  style="display: flex;">
          <span style="margin-right: 10px;padding-top: 10px;width: 100px; ">线下学员</span>
          <el-select
            placeholder="请选择学生"
            v-model="obj1.studentId"
            clearable
            filterable  >
            <el-option
              v-for="item in studentArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div
          class=""  style=" display: flex;" >
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">规划学员</span  ><el-select
            placeholder="请选择学生"
            v-model="obj1.studentId1"
            clearable
            filterable
          >
            <el-option
              v-for="item in studentArr1"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>


    </el-row>

   
    <el-row style="margin-bottom: 20px;">

      <el-col :span="8">
        <div  class="" style=" display: flex;" >
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">教师姓名</span  ><el-select
            placeholder="请选择"
            v-model="obj.teacherId"
            clearable
            filterable  >
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">教师反馈情况</span
          ><el-select
            placeholder="请选择"
            v-model="obj.accomplish"
            clearable
            filterable
          >
            <el-option
              v-for="item in marketSuccessArr"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px;padding-top: 10px;width: 100px; ">科目</span
          ><el-select
            placeholder="请选择"
            v-model="obj.subject"
            clearable
            filterable
          >
            <el-option
              v-for="item in subjectArr"
              :key="item.id"
              :value="item.id"
              :label="item.categoryName"
            >
            </el-option>
          </el-select>
        </div>
       </el-col>
    </el-row>
    
   

    <el-row style="margin-bottom: 20px">

      
      <el-col :span="8">
        <div class="" style=" display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">销售完成情况</span
          ><el-select
            placeholder="请选择"
            v-model="obj.marketSuccess"
            clearable
            filterable
          >
            <el-option
              v-for="item in marketArr"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>


      <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">首次课筛选</span ><el-select
            placeholder="请选择"
            v-model="obj.isFirst"
            clearable
            filterable >
            <el-option
              v-for="item in marketArr_s"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>


      <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">学生类型</span ><el-select
            placeholder="请选择"
            v-model="obj.classType"
            clearable
            filterable  >
            <el-option
              v-for="item in marketArr_ss"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>
  </el-row>


     

      

  

    <el-row style="margin-bottom: 20px">
       <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">跟进助理</span >
          <el-select
            placeholder="请选择"
            v-model="obj.assistantId"
            clearable
            filterable >
            <el-option
              v-for="item in teacherArrr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">地域：</span>
          <el-select v-model="obj.regionName" clearable filterable placeholder="请选择所在地域" >
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div  class=""  style="display: flex;"  >
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">提交时间：</span ><el-date-picker
            v-model="commitDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </div>
      </el-col>


    </el-row>


    <el-row style="margin-bottom: 20px">
       <el-col :span="8">
        <div class="" style="display: flex;">
          <span style="margin-right: 10px;padding-top: 10px;width: 100px; ">诊断师：</span>
          <el-select v-model="obj.diagnoseTeacherId" clearable filterable placeholder="请选择诊断师" >
              <el-option v-for="item in optionsListt111" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div class="" style=" display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">规划师：</span>
          <el-select v-model="obj.projectTeacherId" clearable filterable placeholder="请选择规划师" >
              <el-option v-for="item in optionsListt1111" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
          </el-select>
        </div>
      </el-col>

       <el-col :span="8">
        <div class="" style=" display: flex;">
          <span style="margin-right: 10px; padding-top: 10px; width: 100px;">学科组：</span>
          <el-select v-model="obj.SubjectGroup" clearable filterable placeholder="请选择学科组" >
              <el-option v-for="item in SubjectGroupList" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>

    

    <el-row>
      <el-col :span="24">
        <div class="" style="text-align: right">
          <el-button type="primary" size="small" class="btns" icon="el-icon-tickets" @click="countBtn">一键计算</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtn">搜索</el-button>
          <el-button type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtn">清空</el-button>
          <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">导出</el-button >
        </div>
      </el-col>
    </el-row>

    <!-- </el-form> -->
    <!-- <div style="text-align: right; width: 97%;">
      <el-button type="primary" @click="countBtn">一键计算</el-button>
      <el-button type="primary" @click="searchBtn">搜索</el-button>
      <el-button type="primary" @click="clearBtn">清空</el-button>
    </div> -->
    <el-table
      :data="tableData"
      stripe
      height="500"
      style="width: 99%; margin: 20px auto"
      border
      :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center',
      }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column prop="classFirstDate" label="日期"> </el-table-column>
      <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
      <el-table-column prop="studentName" label="学生姓名"> </el-table-column>
      <el-table-column prop="teacherName" label="教师姓名"> </el-table-column>

      <el-table-column prop="diagnoseTeacherName" label="诊断师"> </el-table-column>
      <el-table-column prop="projectTeacherName" label="规划师"> </el-table-column>

      <el-table-column prop="assistantName" label="跟进助理"> </el-table-column>
      <el-table-column prop="subjectName" label="科目"> </el-table-column>
      <el-table-column prop="classDate" label="上课时间"> </el-table-column>
      <el-table-column prop="isFirst" label="是否为首次课">
        <template slot-scope="scope">
          <span v-if="scope.row.isFirst == 1">是</span>
          <span v-if="scope.row.isFirst == 2">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="classType" label="学生类型">
        <template slot-scope="scope">
          <span v-if="scope.row.classType == 1">规划</span>
          <span v-if="scope.row.classType == 2">线下</span>
          <span v-if="scope.row.classType == 3">纯补课</span>
        </template>
      </el-table-column>
      <el-table-column prop="accomplish" label="教师反馈情况">
        <template slot-scope="scope">
          <span v-if="scope.row.accomplish == 1">未反馈</span>
          <span v-else>已反馈</span>
        </template>
      </el-table-column>
      <el-table-column prop="commitDate" label="提交时间"> 
        <template slot-scope="scope">
          <span :style="{ color: scope.row.commitType == 1 ? 'red' : '' }">{{ scope.row.commitDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="完成情况截图">
        <template slot-scope="scope">
          <img
            v-if="scope.row.url"
            :src="scope.row.url"
            :alt="scope.row.url"
            style="width: 100%; height: 100%"
            @click="handleImgClick(scope.row.url)"
          />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == -1">驳回</span>
          <span v-if="scope.row.auditStatus == 0">提交</span>
          <span v-if="scope.row.auditStatus == 1">通过</span>
          <span v-if="scope.row.auditStatus == 2">完成</span>
          <span v-else></span>
        </template>
      </el-table-column> -->
      <el-table-column label="课后反馈">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column label="一键驳回" width="200px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="scope.row.accomplish === 2" @click="isChangeMarke(scope.row)">一键驳回</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="address" label="销售完成情况" width="250px">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.marketSuccess"
            @change="changeMarke(scope.row)"
          >
            <el-radio :label="2">已完成</el-radio>
            <el-radio :label="1" :disabled="scope.row.marketSuccess == 2"
              >未完成</el-radio
            >
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" :disabled="scope.row.accomplish === 1" @click="isChangeMarke(scope.row)">一键驳回</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="address" width="250px" label="首次课成功情况">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.success" @change="handleStateChange(scope.row)">
            <el-radio :label="0">未成功</el-radio>
            <el-radio :label="1">已成功</el-radio>
          </el-radio-group>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="obj.pageNo"
      :page-size="obj.pageSize"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <el-dialog title="未成功原因" :visible.sync="flog" width="30%">
      <el-form label-width="50px">
        <el-form-item label="原因">
          <el-input placeholder="请输入" v-model="obj.remark"></el-input
        ></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flog = false">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailDia" width="50%">
      <el-form label-width="100px">
        <el-form-item label="起始反馈课节">
          <el-input
            type="text"
            placeholder="请输入内容"
            :disabled="showInp"
            v-model="startLesson"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="现有反馈课节" v-if="showItem">
          <el-input
            type="text"
            placeholder="请输入内容"
            :disabled="true"
            v-model="nowLesson"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="教师课后反馈">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="content"
          >
          </el-input>
        </el-form-item>
        <!-- <el-form-item style="text-align: left;"><el-button type="primary" size="small" class="btn"
            @click="copyText">复制文本</el-button></el-form-item> -->
        <el-form-item label="相关资料" style="text-align: left">
          <ul style="list-style-type: none">
            <li v-for="(item, index) in fileListL" :key="index">
              <a :href="item.url" download="file">{{ item.name }}</a>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDia = false">取 消</el-button>
        <el-button type="primary" @click="determineBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 教师课后反馈提醒 -->
    <el-dialog
      title="教师课后反馈记录"
      :visible.sync="firstClassIsshow"
      width="90%"
    >
      <el-form class="demo-form-inline" label-width="100px">
        <el-form-item label="日期:">
          <!-- <el-date-picker type="date" placeholder="选择日期" v-model="objBottom.classFirstDate" style="width: 100%;"
            value-format="yyyy-MM-dd">
          </el-date-picker> -->
          <el-date-picker
            v-model="classFirstDates"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学生姓名:">
          <el-select
            placeholder="请选择学生"
            v-model="objBottom.studentId"
            style="width: 100%"
          >
            <el-option
              v-for="item in studentArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教师姓名:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.teacherId"
            style="width: 100%"
          >
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.subject"
            style="width: 100%"
          >
            <el-option
              v-for="item in subjectArr"
              :key="item.id"
              :value="item.id"
              :label="item.categoryName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="首次课计划教师完成情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.accomplish" style="width:100%;">
          <el-option v-for="item in planTeacher" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态:">
        <el-select placeholder="请选择" v-model="obj.auditStatus" style="width:100%;">
          <el-option v-for="item in auditStatusArr" :key="item.value" :value="item.value" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="教师反馈情况:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.accomplish"
            style="width: 100%"
          >
            <el-option
              v-for="item in marketSuccessArr"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="首次课成功情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.success" style="width:100%;">
          <el-option v-for="item in firstClassState" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="searchBtns">搜索</el-button>
          <el-button type="primary" @click="clearBtns">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData1"
        stripe
        style="width: 99%; margin: 20px auto"
        border
        :header-cell-style="{
          background: '#fafafa',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="classFirstDate" label="日期"> </el-table-column>
        <el-table-column prop="studentName" label="学生姓名"> </el-table-column>
        <el-table-column prop="teacherName" label="教师姓名"> </el-table-column>
        <el-table-column prop="subjectName" label="科目"> </el-table-column>
        <el-table-column prop="classDate" label="上课时间"> </el-table-column>
        <el-table-column prop="accomplish" label="教师反馈情况">
          <template slot-scope="scope">
            <span v-if="scope.row.accomplish == 1">未反馈</span>
            <span v-else>已反馈</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == -1">驳回</span>
          <span v-if="scope.row.auditStatus == 0">提交</span>
          <span v-if="scope.row.auditStatus == 1">通过</span>
          <span v-if="scope.row.auditStatus == 2">完成</span>
          <span v-else></span>
        </template>
      </el-table-column> -->
        <!-- <el-table-column label="课后反馈">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row.id)">详情</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="address" label="销售完成情况" width="250px">
          <template slot-scope="scope">
            <span v-if="scope.row.marketSuccess == 1">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="address" width="250px" label="首次课成功情况">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.success" @change="handleStateChange(scope.row)">
            <el-radio :label="0">未成功</el-radio>
            <el-radio :label="1">已成功</el-radio>
          </el-radio-group>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="objBottom.pageNo"
        :page-size="objBottom.pageSize"
        layout="total, prev, pager, next"
        :total="total1"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="firstClassIsshow = false">取 消</el-button>
        <el-button type="primary" @click="firstClassIsshow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="请上传完成截图" :visible="screenshotShow" width="50%" @before-close="handlescreenshotCler">
      <el-upload
        class="avatar-uploader"
        ref="upload"
        action="#"
        drag
        :on-remove="handleRemove"
        :beforeUpload="beforeUpload"
        :file-list="fileList"
        :http-request="handleUpload"
        :auto-upload="true"
        :limit="1"
        accept=".png,.jpg,.pdf"
      >
        <img
          v-if="screenshot"
          :src="screenshot"
          style="width: 100%; height: 100%"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <div class="dialog-footer" style="margin-top: 100px">
        <el-button @click="handlescreenshotCler" style="margin-right: 50px"
          >取 消</el-button
        >
        <el-button type="primary" @click="handlescreenshotSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isShowImg" width="50%">
      <el-image v-if="isShowImg" :src="showImg"></el-image>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  getTeachers,
  changeFirstClass,
  getStudents,
  getStudentsType,
  markeStatus,
  getSubject,
  getdeta,
  count,
  determine,
} from "@/api/feedBackApi";
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data() {
    return {

      optionsListt111: [],
      optionsListt1111: [],


      showImg: "",
      isShowImg: false,
      screenshotShow: false,
      screenshot: "",
      fileListL: [],
      id: "",
      content: "",
      showInp: true,
      showItem: true,
      startLesson: null,
      nowLesson: null,
      tableData: [], //表格数据
      tableData1: [], //表格数据
      teacherArr: [], //所有老师
      studentArr: [], //所有学生
      studentArr1: [], //所有学生
      subjectArr: [], //所有科目
      fileList: [],
      firstClassIsshow: false,
      firstClassState: [
        { value: 0, label: "未成功" },
        { value: 1, label: "已成功" },
      ],
      planTeacher: [
        { value: 1, label: "未完成" },
        { value: 2, label: "已完成" },
      ],
      auditStatusArr: [
        { value: 3, name: "驳回" },
        { value: 0, name: "提交" },
        { value: 1, name: "通过" },
        { value: 2, name: "完成" },
      ],
      marketSuccessArr: [
        { value: 1, label: "未反馈" },
        { value: 2, label: "已反馈" },
      ],
      marketArr: [
        { value: 1, label: "未完成" },
        { value: 2, label: "已完成" },
      ],
      marketArr_s: [
        { value: 1, label: "是" },
        { value: 2, label: "否" },
      ],
      marketArr_ss:[
      { value: 1, label: "规划" },
      { value: 2, label: "线下" },
      { value: 3, label: "纯补课" },
      ],
      SubjectGroupList: [],
      obj: {
        SubjectGroup: "",
        marketSuccess: "", //销售完成情况
        auditStatus: "", //审核状态
        accomplish: "", //首次课教师计划完成情况
        // classFirstDate: '',//首次课日期 搜索框
        startTime: "",
        diagnoseTeacherId: "",
        projectTeacherId: "",
        endTime: "",
        teacherId: "", //教师Id 搜索框
        subject: "", //科目  搜索框
        studentId: "", //学生Id 搜索框
        id: "",
        success: null,
        remark: "",
        pageNo: 1,
        pageSize: 10,
        isFirst: "",
        classType:"",
        assistantId:'',
        regionName:'',
      },
      teacherArrr:[],
      obj1:{
        studentId:"",
        studentId1:"",
      },
      success: "",
      marketSuccess: "",
      classFirstDate: [],
      classFirstDates: [],
      objBottom: {
        startTime: "",
        endTime: "",
        marketSuccess: "", //销售完成情况
        auditStatus: "", //审核状态
        accomplish: "", //首次课教师计划完成情况
        // classFirstDate: '',//首次课日期 搜索框
        teacherId: "", //教师Id 搜索框
        subject: "", //科目  搜索框
        studentId: "", //学生Id 搜索框
        id: "",
        success: "",
        remark: "",
        pageNo: 1,
        pageSize: 10,
      },
      detailDia: false,
      dialogVisible: false,
      flog: false,
      // firstClassTeaeh: [{value:}],
      total: 0, //总条数
      total1: 0,
      // paging: {//分页
      //   pageNo: 1,
      //   pageSize: 10,
      // },

      dataTop: {
        allTotal:0,
        marketNotOk:0,
        marketOk:0,
        teacherNotOk:0,
        teacherOk:0,
      },

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      commitDate: [], //提交时间

    };
  },
  created() {
    this.getListData();
    this.getTeacher();
    this.getStudent();
    this.getAllSubject();

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },
  mounted(){
    
    this.optionsListt1111 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.optionsListt111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))

  },

  methods: {
    downloadBtn(){
      let studentIds = ""
      let obj = {}
      if(this.obj1.studentId){
        studentIds = this.obj1.studentId + ''
        if(this.obj1.studentId1){
          studentIds =  this.obj1.studentId + ',' + this.obj1.studentId1
        }
      }else{
        if(this.obj1.studentId1){
          studentIds = this.obj1.studentId1  + ''
        }
      }
      if(studentIds){
         obj.studentIds = studentIds
      }else{
         obj.studentIds = ""
      }

      let data = {
        marketSuccess:this.obj.marketSuccess,
        auditStatus: this.obj.auditStatus,
        accomplish: this.obj.accomplish,
        endTime: this.classFirstDate.length > 0 ?  this.classFirstDate[1]  : '',
        startTime:  this.classFirstDate.length > 0 ? this.classFirstDate[0]  : '',
        teacherId:  this.obj.teacherId,
        subject:  this.obj.subject,
        studentId: this.obj.studentId,
        id: this.obj.id,
        success: this.obj.success,
        remark: this.obj.remark,
        pageNo: this.obj.pageNo,
        pageSize: this.obj.pageSize,
        isFirst: this.obj.isFirst,
        classType: this.obj.classType,
        assistantId: this.obj.assistantId,
        regionName: this.obj.regionName || localStorage.getItem('cityTepy'),

        commitEndDate: this.commitDate.length > 0 ?  this.commitDate[1] + ' 23:59:59': '',
        commitStartDate:  this.commitDate.length > 0 ? this.commitDate[0] + ' 00:00:00' : '',

        diagnoseTeacherId:this.obj.diagnoseTeacherId,
        projectTeacherId:this.obj.projectTeacherId,
        categoryIds: this.obj.SubjectGroup,

      }


      let datas = Object.assign(data,obj)


      axios.post(`${apiBaseUrl}/teacherFeedback/excelTeacherFeeback`, datas, { responseType: "blob",headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "教师课后反馈.xlsx";
          downloadLink.click();
      });
    },
    handleImgClick(row) {
      this.showImg = row;
      this.isShowImg = true;
    },
    //详情确定按钮
    determineBtn() {
      let data = {
        id: this.id,
        startLesson: this.startLesson,
      };
      if (
        (this.nowLesson && this.startLesson) ||
        (this.nowLesson == null && this.startLesson == null)
      ) {
        this.detailDia = false;
      } else {
        determine(data).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.detailDia = false;
          } else {
            this.$message.error(res.message);
          }
        });
      }
      //  if (this.nowLesson == null) {
      //   determine(data).then(res => {
      //     if (res.code == 200) {
      //       this.$message.success(res.message)
      //       this.detailDia = false
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
      // }
    },
    copyText() {
      navigator.clipboard
        .writeText(this.content)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch((err) => {
          this.$message.error("复制失败");
          console.log("复制失败", err);
        });
    },
    //一键计算
    countBtn() {
      count().then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.getListData();
      });
    },
    //获取所有科目
    getAllSubject() {
      getSubject().then((res) => {
        this.subjectArr = res.data;
      });
    },
    //获取表格数据
    getListData() {
      let studentIds = ""
      let obj = {}
      if(this.obj1.studentId){
        studentIds = this.obj1.studentId + ''
        if(this.obj1.studentId1){
          studentIds =  this.obj1.studentId + ',' + this.obj1.studentId1
        }
      }else{
        if(this.obj1.studentId1){
          studentIds = this.obj1.studentId1  + ''
        }
      }
      if(studentIds){
         obj.studentIds = studentIds
      }else{
         obj.studentIds = ""
      }

      let data = {
        marketSuccess:this.obj.marketSuccess,
        auditStatus: this.obj.auditStatus,
        accomplish: this.obj.accomplish,
        endTime: this.classFirstDate.length > 0 ?  this.classFirstDate[1]  : '',
        startTime:  this.classFirstDate.length > 0 ? this.classFirstDate[0]  : '',
        teacherId:  this.obj.teacherId,
        subject:  this.obj.subject,
        studentId: this.obj.studentId,
        id: this.obj.id,
        success: this.obj.success,
        remark: this.obj.remark,
        pageNo: this.obj.pageNo,
        pageSize: this.obj.pageSize,
        isFirst: this.obj.isFirst,
        classType: this.obj.classType,
        assistantId: this.obj.assistantId,
        regionName: this.obj.regionName || localStorage.getItem('cityTepy'),

        commitEndDate: this.commitDate.length > 0 ?  this.commitDate[1] + ' 23:59:59': '',
        commitStartDate:  this.commitDate.length > 0 ? this.commitDate[0] + ' 00:00:00' : '',

        diagnoseTeacherId:this.obj.diagnoseTeacherId,
        projectTeacherId:this.obj.projectTeacherId,
        categoryIds: this.obj.SubjectGroup,

      }


      let datas = Object.assign(data,obj)
      // console.log("%c Line:983 🎂 datas", "color:#ed9ec7", datas);


      getList(datas).then((res) => {
        this.tableData = res.data.page.records;
        this.dataTop = res.data;
        this.total = res.data.page.total;
      });
    },
    //获取所有老师
    getTeacher() {
      getTeachers().then((res) => {
        this.teacherArr = res.data;
      });
      axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => { this.teacherArrr = response.data.data;  })

    },
    //获取所有老师
    getStudent() {
      // getStudents().then((res) => {
      //   this.studentArr = res.data;
      // });

      getStudentsType(2).then(res => {
        this.studentArr = res.data
      })
      getStudentsType(1).then(_res => {
        this.studentArr1 = _res.data
      })

    },

    isChangeMarke(row){
        axios.put(`${apiBaseUrl}/teacherFeedback/oneClickHsiangHsien?id=${row.id}`,{},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
          if(res.data.code == 200){
              this.$message({ message: res.data.message , type: "success" });
          }else{
              this.$message({ message: res.data.message , type: "error" });
          }
        })
    },
    //修改销售完成情况
    changeMarke(row) {
      if (row.accomplish == 1) {
        this.$message({ message: "教师反馈情况必须为已反馈", type: "warning" });
        row.marketSuccess = 1;
      } else {
        let type = row.marketSuccess;
        this.$confirm("此操作将修改销售完成情况, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.screenshotShow = true;
            this.screenshotRow = row;
          })
          .catch(() => {
            row.marketSuccess = type == 1 ? 2 : 1;
            this.$message({
              type: "warning",
              message: "已取消",
            });
          });
      }
    },
    handlescreenshotSubmit() {
      this.screenshotShow = false;
      let row = this.screenshotRow;
      row.url = this.screenshot;
      markeStatus(row).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.screenshot = "";
        this.fileList = [];
        this.getListData();
      });
    },
    handlescreenshotCler() {
      this.tableData.forEach((itme) => {
        if (itme.id == this.screenshotRow.id) {
          itme.marketSuccess = 1;
        }
      });
      this.screenshot = "";
      this.screenshotShow = false;
      this.fileList = [];
    },
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf" ||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        console.log(res);
        this.screenshot = res.url;
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          console.log(res);
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.screenshot = "";
    },
    //修改状态
    handleStateChange(row) {
      this.obj.remark = "";
      if (row.marketSuccess == 1) {
        this.flog = true;
      } else {
        changeFirstClass(this.obj).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.getListData();
        });
      }
      this.obj.id = row.id;
      this.obj.marketSuccess = row.marketSuccess;
    },
    //原因保存
    saveRemark() {
      changeFirstClass(this.obj).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getListData();
          this.flog = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //搜索按钮
    searchBtn() {
        this.obj.startTime = this.classFirstDate.length > 0 ? this.classFirstDate[0]: ""
        this.obj.endTime = this.classFirstDate.length > 0 ? this.classFirstDate[1]: ""
        this.obj.pageNo = 1
        this.getListData();
    },
    searchBtns() {
        this.objBottom.marketSuccess =
        this.marketSuccess == "" ? 8 : this.marketSuccess;
        this.objBottom.startTime = this.classFirstDate?this.classFirstDates[0]:""
        this.objBottom.endTime = this.classFirstDate?this.classFirstDates[1]:""
        this.objBottom.pageNo = 1
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.records;
        this.total1 = res.data.total;
      });
    },
    //清空按钮
    clearBtn() {
      this.obj.marketSuccess = "";
      this.obj.auditStatus = "";
      this.obj.accomplish = "";
      this.classFirstDate = [];
      this.obj.startTime = "";
      this.obj.endTime = "";
      this.obj.teacherId = "";
      this.obj.studentId = "";
      this.obj.assistantId = "";
      this.obj1.studentId1 = "";
      this.obj1.studentId = "";
      this.obj.SubjectGroup = ""

      this.obj.diagnoseTeacherId =  "";
      this.obj.projectTeacherId =  "";

      this.obj.subject = "";
      this.obj.isFirst = "";
      this.obj.classType = ""
      this.obj.regionName = "";

      this.obj.pageNo = 1;

      this.commitDate = []

      this.getListData();
    },
    clearBtns() {
      this.objBottom.marketSuccess = "";
      this.objBottom.auditStatus = "";
      this.objBottom.accomplish = "";
      this.classFirstDates = [];
      this.objBottom.startTime = "";
      this.objBottom.endTime = "";
      this.objBottom.teacherId = "";
      this.objBottom.studentId = "";
      this.objBottom.subject = "";
      this.marketSuccess = "";
      this.objBottom.marketSuccess = 8;
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.records;
        this.total = res.data.total;
      });
    },
    //点击首次课历史记录
    historyBtn() {
      this.firstClassIsshow = true;
      this.objBottom.marketSuccess = 8;
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.records;
        this.total1 = res.data.total;
      });
    },
    //详情
    detail(id) {
      this.id = id;
      this.detailDia = true;
      getdeta(id).then((res) => {
        this.startLesson = res.data.startLesson;
        if (res.data.startLesson == null) {
          this.showInp = false;
        } else {
          this.showInp = true;
        }
        if (res.data.nowLesson == null) {
          this.showItem = false;
        } else {
          this.showItem = true;
        }
        this.nowLesson = res.data.nowLesson;
        this.content = res.data.content;
        this.fileListL = res.data.urlList;
      });
    },
    //分页
    handleSizeChange(v) {
      console.log(v);
    },
    handleCurrentChange(v) {
      // console.log(v);
      this.obj.pageNo = v;
      this.getListData();
    },
    //分页
    handleSizeChange1() {},
    handleCurrentChange1(v) {
      this.objBottom.pageNo = v;
      this.getListData();
    },
  },
};
</script>

<style scope>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.el-upload {
  border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  
}

/* .demo-form-inline { */
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
/* } */

/* .demo-form-inline .el-form-item {
  
} */

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa >>> .fiveLessons {
    width: 70% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/afterSales/feedBack.vue